import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { alpha, useTheme } from '@mui/material/styles';

import { useAuthContext } from 'src/auth/hooks';

import Iconify from '../iconify';
import PricingView from '../pricing/view';
import ReactivateAccess from '../reactivate-access';

// ----------------------------------------------------------------------

export default function Paywall ({ message, showIcon = true }) {
  const theme = useTheme();
  const { user } = useAuthContext();

  // NOTE: This route is currently unreachable. hasPaidAccess() (src/auth/guard/has-paid-access.js)
  // grants full access to past_due users (grace period while Stripe retries payment),
  // so they never reach the Paywall. If we ever decide to block past_due users and
  // show them the paywall, this path will direct them to the Stripe portal to update
  // their payment method.
  const isPastDue = user?.status === 'past_due';

  if (isPastDue && user?.stripeCustomerId && user?.stripeSubscriptionId) {
    return <ReactivateAccess />;
  }

  // Otherwise, show pricing plans for new users
  return (
    <Container>
      <Box
        sx={{
          // py: 12,
          // maxWidth: 600,
          mx: 'auto',
          display: 'flex',
          minHeight: '100vh',
          textAlign: 'center',
          alignItems: 'center',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        {showIcon && (
          <Box
            sx={{
              // mb: 3,
              width: 120,
              height: 120,
              borderRadius: '50%',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.12)} 0%, ${alpha(theme.palette.primary.main, 0.24)} 100%)`,
            }}
          >
            <Iconify
              icon="solar:lock-password-unlocked-bold-duotone"
              width={64}
              sx={{ color: 'primary.main' }}
            />
          </Box>
        )}

        <PricingView />
      </Box>
    </Container>
  );
}

Paywall.propTypes = {
  message: PropTypes.string,
  showIcon: PropTypes.bool,
};
